import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import DatePicker from 'react-datepicker';
import { InputLabel, ErrorMessageBar, InputError } from 'src/domains/layouts/shared/formComponents/FormComponents.style';
import { FormWrapper, FormComponent, DatesWrapper, DateInputWrapper, SectionHeaderLabel } from 'src/domains/layouts/shared/cms/form/Form.style';
import { HeroWidgetImageUpload } from './HeroWidgetImageUpload/HeroWidgetImageUpload';
import { HeroWidgetFormState } from './HeroWidgetForm.state';
import { FormHeader } from 'src/domains/layouts/shared/cms/form/formHeader/FormHeader';
import { OldInput } from 'src/domains/layouts/shared/formComponents/input/OldInput';
import { OldTextarea } from 'src/domains/layouts/shared/formComponents/textarea/OldTextarea';
import { FormButtons } from 'src/domains/layouts/shared/buttons/FormButtons';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

export const HeroWidgetForm = observer(() => {
    const { heroWidgetState } = useAppStateContext();
    const [ state ] = React.useState(() => new HeroWidgetFormState(heroWidgetState));
    const { preventDefault, onChangeStartDate, onBlurStartDate, onChangeEndDate, onBlurEndDate, startDateError, endDateError } = state;
    const {
        isLoading,
        errorMessage,
        isFormValid,
        isEditMode,
        handleSubmit,
        handleCancel,
        resetForm,
        startDate, endDate,
        titleStatus, title, titleModel,
        subtitleStatus, subtitle, subtitleModel,
        tcTitle, tcTitleModel, tcTitleStatus,
        tcText, tcTextModel, tcTextStatus,
        headerBgColorStatus, headerBgColor, headerBgColorModel,
        promoBgColorStatus, promoBgColor, promoBgColorModel,
        eventIdStatus, eventId, eventIdModel,
        marketIdStatus, marketId, marketIdModel,
    } = heroWidgetState;

    return (
        <FormWrapper>
            <FormHeader isEditMode={isEditMode} defaultLabel='Create new hero widget' editModeLabel='Edit hero widget' resetForm={resetForm}/>
            <FormComponent onSubmit={preventDefault}>
                <Loader isActive={isLoading}/>

                {!!errorMessage && <ErrorMessageBar>{errorMessage}</ErrorMessageBar>}

                <OldInput
                    label='Title (max 255 characters) *'
                    status={titleStatus}
                    formInputState={title}
                    model={titleModel}
                    dataTest='set-hero-widget-title'
                />

                <OldInput
                    label='Subtitle (max 255 characters)'
                    status={subtitleStatus}
                    formInputState={subtitle}
                    model={subtitleModel}
                    dataTest='set-hero-widget-subtitle'
                />

                <OldInput
                    label='Terms title (max 20 characters)'
                    status={tcTitleStatus}
                    formInputState={tcTitle}
                    model={tcTitleModel}
                    dataTest='set-hero-widget-terms-title'
                />

                <OldTextarea
                    label='Terms'
                    formState={tcText}
                    model={tcTextModel}
                    status={tcTextStatus}
                    ckeditor
                />

                <OldInput
                    label='Header background colour (#hex value only)'
                    status={headerBgColorStatus}
                    formInputState={headerBgColor}
                    model={headerBgColorModel}
                    dataTest='set-header-background-colour'
                />

                <OldInput
                    label='Promo background colour (#hex value only)'
                    status={promoBgColorStatus}
                    formInputState={promoBgColor}
                    model={promoBgColorModel}
                    dataTest='set-promo-background-colour'
                />

                <OldInput
                    label='Event ID number*'
                    status={eventIdStatus}
                    formInputState={eventId}
                    model={eventIdModel}
                    dataTest='set-event-id'
                />

                <OldInput
                    label='Market ID number*'
                    status={marketIdStatus}
                    formInputState={marketId}
                    model={marketIdModel}
                    dataTest='set-market-id'
                />

                <SectionHeaderLabel>Publishing</SectionHeaderLabel>

                <DatesWrapper>
                    <DateInputWrapper>
                        <InputLabel>Start date *</InputLabel>
                        <DatePicker
                            selected={startDate}
                            onChange={onChangeStartDate}
                            onBlur={onBlurStartDate}
                            showTimeSelect
                            timeFormat='HH:mm'
                            timeIntervals={15}
                            timeCaption='time'
                            dateFormat='MMMM d, yyyy h:mm aa'
                            id='Start-date'
                        />
                        {startDateError ? <InputError>This field is required.</InputError> : null}
                    </DateInputWrapper>
                    <DateInputWrapper>
                        <InputLabel>End date *</InputLabel>
                        <DatePicker
                            selected={endDate}
                            onChange={onChangeEndDate}
                            onBlur={onBlurEndDate}
                            showTimeSelect
                            timeFormat='HH:mm'
                            timeIntervals={15}
                            timeCaption='time'
                            dateFormat='MMMM d, yyyy h:mm aa'
                            id='End-date'
                        />
                        {endDateError ? <InputError>This field is required.</InputError> : null}
                    </DateInputWrapper>
                </DatesWrapper>

                <HeroWidgetImageUpload />

                <FormButtons
                    onCreate={handleSubmit}
                    onUpdate={handleSubmit}
                    onCancel={handleCancel}
                    isEditMode={isEditMode}
                    isCreateDisabled={!isFormValid}
                    isUpdateDisabled={!isFormValid}
                    dataTestCreate='create-hero-widget-button'
                    dataTestUpdate='update-hero-widget-button'
                />
            </FormComponent>
        </FormWrapper>
    );
});

